import React from "react";
import axios from "axios";
import { login as API_LOGIN } from "./config/api";
import { sys as API_SYS } from "./config/api";
import { setup as URI_SETUP } from "./config/api";
import Login from "./Login";
//Componentes
import Header from "./components/Header";
import SidebarLeft from "./components/SidebarLeft";
import SidebarNotifications from "./components/SidebarNotifications";

//Layouts
import LayoutAccount from "./modules/account/Layout.js";
import LayoutSetup from "./modules/setup/Layout.js";
import LayoutSupport from "./modules/support/Layout.js";
import LayoutLegal from "./modules/legal/Layout.js";

const postUrlLogin = API_LOGIN;
const sysUrl = API_SYS;
const uri_hotels = URI_SETUP+"hotel";
const uri_data_source_csv = URI_SETUP+"data_source/csv/schema";

class SetupApp extends React.Component{
  
  constructor(props){
    super(props);
    this.state = {
      first_request             : true,
      isVisible                 : "loading-wait",
      layout_active             : "setup",
      section_active            : "parsing-db",
      hotel_selected            : "",
      status_sb_notifications   : "",
      is_login                  : true,
      sys_catalogs              : [],
      sys_tree                  : [],
      hotels                    : [],
      parsing_schema_list       : [],
    }
    this.setSession = this.setSession.bind(this);
    this.activeSection = this.activeSection.bind(this);
    this.refreshCatalogSys = this.refreshCatalogSys.bind(this);
    this.getHotels = this.getHotels.bind(this);
    this.setActiveHotel = this.setActiveHotel.bind(this);
    this.renderSelectHotels = this.renderSelectHotels.bind(this);
    this.handleStatusNotifications = this.handleStatusNotifications.bind(this);
    this.openStatusNotifications = this.openStatusNotifications.bind(this);

  }
  componentWillMount(){
    this.verifyToken();
    this.sysStartup();
    this.getHotels();
    this.setActiveHotel('5b7ddc24712c9875767aa808'); //tmp
  }

  sysStartup() {
    let self = this;
    axios.get(sysUrl+"startup", { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => {
        self.setState({ 
          sys_catalogs          : request.data.catalogs,
          sys_tree              : request.data.tree
        }) 
    })

  }

  refreshCatalogSys() {
    let self = this;
    axios.get(sysUrl+"catalog", { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => {
        self.setState({ 
          sys_catalogs          : request.data
        }) 
    })

  }

  activeSection(layout,section,hotel_selected){
    let self = this;
    self.setState({
      layout_active : layout,
      section_active : section,
      hotel_selected : hotel_selected
    })
  }
  setSession(state){
    let self = this;
    self.setState({
      is_login : state,      
    })
  }
  verifyToken(){
    let self = this;
    if(self.state.isVisible === "loading-wait"){
      let data = {
        api_token : localStorage.getItem("api_token")
      };
      let qs = require("qs");
      axios.post(postUrlLogin, qs.stringify(data))
      .then(function (response) {
          if ( response.data["status"] === "error" ){
              localStorage.removeItem("api_token");
              localStorage.removeItem("name");
              localStorage.removeItem("email");
              self.setState({
                is_login : false,
                first_request : true
              })
          }else{
            self.setState({
              is_login : true,
              isVisible : "",
            }, function(){
              setTimeout(() => {
                self.setState({
                  isVisible: "loading-success",
                  first_request : false
                })
              }, 1000);
            })
          }
      })
      .catch(function (error) {
      });
    }
  }

  handleStatusNotifications(){
    let sbn_status="";
    sbn_status=(this.state.status_sb_notifications=="")?"open":"";
    this.setState({ 
      status_sb_notifications : sbn_status
      }) 
  }

  openStatusNotifications(){
    this.setState({ 
      status_sb_notifications : ""
      }) 
  }

  handleHotelChange = (event) => {
    this.setActiveHotel(event.target.value);
  };

  setActiveHotel(hotel){
    hotel= (hotel=='')? this.state.hotel_selected : hotel;
    let self = this;
    axios.get(uri_data_source_csv, { 
      params: {
          api_token   : localStorage.getItem("api_token"),
          property    : hotel
      }
    }).then(request => { 
        self.setState({ 
            parsing_schema_list : request.data,
            hotel_selected : hotel 
            }) 
        }) 

    
  }

  getHotels() {
    let self = this;
    axios.get(uri_hotels, { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => { 
        self.setState({ 
        hotels                  : request.data
        }) 
    })
  } 


  renderSelectHotels() {
    return  <select className="form-control top-form-select " name="hotel_id" value={this.state.hotel_selected}  onChange={this.handleHotelChange}  >
                <option disabled>HOTEL</option>
                {Object.keys(this.state.hotels).map((key, index) => {
                    return ( <option value={this.state.hotels[key]._id} key={index}> {this.state.hotels[key].name}</option>);
                    })
                }
            </select> 
  }
  
  render(){
    if(this.state.is_login){
      return(
        <div className="container-general">
            <div className={ "loading-general " + this.state.isVisible }>
              <span></span>
            </div>
            <Header
              setSession={this.setSession}
            />
            <main className="container-fluid main-container">
              <SidebarLeft
                setSession={this.setSession}
                activeSection={this.activeSection}
                setActiveHotel = {this.setActiveHotel}
                menu={this.state.sys_tree}
                hotels={this.state.hotels}
                app={this}
              />
              <div className="content">
                <div className={"account " + (this.state.layout_active !== "account" ? "hide" : "") }>
                  <LayoutAccount
                    app={this}
                  />
                </div>
                <div className={"setup " + (this.state.layout_active !== "setup" ? "hide" : "") }>
                  <LayoutSetup
                    catalogs={this.state.sys_catalogs}
                    refreshCatalogSys={this.refreshCatalogSys}
                    setActiveHotel = {this.setActiveHotel}
                    renderSelectHotels = {this.renderSelectHotels}
                    openStatusNotifications={this.openStatusNotifications}
                    app={this}
                  />
                </div>
                <div className={"support " + (this.state.layout_active !== "support" ? "hide" : "") }>
                  <LayoutSupport
                    app={this}
                  />
                </div>
                <div className={"legal " + (this.state.layout_active !== "legal" ? "hide" : "") }>
                  <LayoutLegal
                    app={this}
                  />
                </div>


              </div>
              <SidebarNotifications
                handleStatusNotifications={this.handleStatusNotifications}
                app={this}
              />
          

            </main>
            <div className="with-love">
              <div>
                <span>Made with <i className="fa fa-heart"></i> by Axovia</span>
              </div>
            </div>
        </div>
      )
    }else{
      return (
        <div>
          <Login 
            setSession={this.setSession}
          />
        </div>
      )
    }
  }
};
export default SetupApp


// WEBPACK FOOTER //
// ./src/Setup/App.js